/* MagicPad listicle design reminder: preserve the reference's compact editorial motion,
   responsive sticky conversion path, and simple tactile controls. All content remains
   product-driven or intentionally blank until genuine MagicPad assets and reviews are supplied. */
(() => {
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents, currency) => new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100);
  const q = (root, selector) => root.querySelector(selector);
  const qa = (root, selector) => Array.from(root.querySelectorAll(selector));

  function initReviewMarquee(root) {
    const marquee = root.querySelector('.ffdlp-review-marquee');
    if (!marquee || marquee.dataset.ffMarqueeInit) return;
    marquee.dataset.ffMarqueeInit = 'true';
    const track = marquee.querySelector('.ffdlp-review-marquee__track');
    const set = marquee.querySelector('.ffdlp-review-marquee__set');
    if (!track || !set || reducedMotion) return;

    const applyShift = () => {
      const w = set.getBoundingClientRect().width;
      if (w > 1) {
        track.style.setProperty('--ffdlp-marquee-shift', Math.round(w) + 'px');
      }
    };

    applyShift();
    requestAnimationFrame(() => {
      applyShift();
      requestAnimationFrame(applyShift);
    });
    window.addEventListener('resize', applyShift, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(applyShift).catch(() => {});
    }
    // Pause while finger is down so mobile users can read
    const viewport = marquee.querySelector('.ffdlp-review-marquee__viewport');
    if (viewport) {
      viewport.addEventListener('touchstart', () => { track.style.animationPlayState = 'paused'; }, { passive: true });
      viewport.addEventListener('touchend', () => { track.style.animationPlayState = ''; }, { passive: true });
    }
  }



  function initFbComments(root) {
    if (!root || root.dataset.ffFbInitialised) return;
    root.dataset.ffFbInitialised = 'true';

    const modal = q(root, '[data-modal-overlay]');
    const modalBox = q(root, '.ml-modal__box');
    let lastFocus;
    function openModal(name) {
      if (!modal) return;
      lastFocus = document.activeElement;
      qa(root, '[data-modal-panel]').forEach((panel) => { panel.hidden = panel.dataset.modalPanel !== name; });
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      window.setTimeout(() => modalBox?.focus(), 50);
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lastFocus?.focus?.();
    }
    q(root, '[data-close-modal]')?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal?.classList.contains('is-open')) closeModal(); });

    const fbRoot = root.matches('[data-fb-comments]') ? root : q(root, '[data-fb-comments]');
    if (fbRoot) {
      const source = q(fbRoot, '[data-fb-source]');
      const wall = q(fbRoot, '[data-fb-wall]');
      const pills = qa(fbRoot, '[data-fb-filter]');
      const select = q(fbRoot, '[data-fb-filter-select]');
      const showingLabel = q(fbRoot, '[data-fb-filter-label]');
      let filter = 'all';

      function columnCount() {
        const w = window.innerWidth || 800;
        if (w >= 980) return 3;
        if (w >= 560) return 2;
        return 1;
      }

      function esc(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }
      function openFbModal(card) {
        const panel = q(root, '[data-modal-panel="fb-comment"]');
        if (!panel || !card) return;
        const name = card.dataset.name || '';
        const time = card.dataset.time || '';
        const location = card.dataset.location || '';
        const body = card.dataset.body || '';
        const likes = card.dataset.likes || '';
        const color = /^#[0-9A-Fa-f]{3,8}$/.test(card.dataset.avatarColor || '')
          ? card.dataset.avatarColor
          : '#1877F2';
        const initials = esc(card.dataset.initials || (name.charAt(0) || '?').toUpperCase());
        const avatarUrl = card.dataset.avatarUrl || '';
        const avatarHtml = avatarUrl
          ? `<img src="${esc(avatarUrl)}" alt="" width="44" height="44" loading="lazy">`
          : initials;
        const metaBits = [time, location].filter(Boolean).map(esc).join(' · ');
        const likesHtml = likes && Number(likes) > 0
          ? `<span class="ffdlp-fb-likes">👍 ${esc(likes)}</span>`
          : '';
        panel.innerHTML = `
          <div class="ffdlp-fb-modal-card">
            <div class="ffdlp-fb-card__head">
              <span class="ffdlp-fb-ava" style="background:${color};width:44px;height:44px;flex-basis:44px">${avatarHtml}</span>
              <div class="ffdlp-fb-who">
                <span class="ffdlp-fb-name">${esc(name)}</span>
                <span class="ffdlp-fb-meta">${metaBits}</span>
              </div>
            </div>
            <p class="ffdlp-fb-body">${esc(body)}</p>
            <div class="ffdlp-fb-actions">
              <button type="button" tabindex="-1">Like</button>
              <span class="ffdlp-fb-actions__sep">·</span>
              <button type="button" tabindex="-1">Reply</button>
              ${likesHtml ? `<span class="ffdlp-fb-actions__sep">·</span>${likesHtml}` : ''}
            </div>
          </div>`;
        openModal('fb-comment');
      }

      function makeLiveCard(sourceCard) {
        const card = sourceCard.cloneNode(true);
        card.removeAttribute('hidden');
        card.classList.remove('ffdlp-fb-source-card');
        const bodyEl = q(card, '[data-fb-body]');
        if (bodyEl) {
          const full = sourceCard.dataset.body || bodyEl.textContent || '';
          bodyEl.textContent = full;
          const needsClamp = full.length > 180;
          bodyEl.classList.toggle('is-clamp', needsClamp);
          let more = q(card, '[data-fb-more]');
          if (needsClamp) {
            if (!more) {
              more = document.createElement('button');
              more.type = 'button';
              more.className = 'ffdlp-fb-more';
              more.dataset.fbMore = '';
              more.textContent = 'See more';
              bodyEl.insertAdjacentElement('afterend', more);
            }
          } else if (more) {
            more.remove();
          }
        }
        card.addEventListener('click', (event) => {
          if (event.target.closest('[data-fb-like], [data-fb-reply]')) {
            event.preventDefault();
            return;
          }
          openFbModal(sourceCard);
        });
        return card;
      }

      function buildWall() {
        if (!source || !wall) return;
        const cards = qa(source, '[data-fb-card]').filter((card) => {
          const key = (card.dataset.filter || 'all').toLowerCase();
          return filter === 'all' || key === filter;
        });
        const cols = columnCount();
        wall.innerHTML = '';
        wall.style.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;
        if (!cards.length) {
          const empty = document.createElement('p');
          empty.className = 'ffdlp-fb-sub';
          empty.textContent = 'No comments in this filter yet.';
          wall.appendChild(empty);
          return;
        }
        const buckets = Array.from({ length: cols }, () => []);
        cards.forEach((card, index) => buckets[index % cols].push(card));
        const durs = [4.6, 5.5, 4.9];
        buckets.forEach((bucket, ci) => {
          const col = document.createElement('div');
          col.className = 'ffdlp-fb-col';
          const slice = bucket.length ? bucket : cards;
          for (let pass = 0; pass < 2; pass += 1) {
            slice.forEach((src) => col.appendChild(makeLiveCard(src)));
          }
          const dur = Math.max(20, Math.round(Math.max(slice.length, 1) * (durs[ci] || 5)));
          col.style.setProperty('--wallDur', `${dur}s`);
          col.style.setProperty('--wallDelay', `${-ci * 6}s`);
          wall.appendChild(col);
        });
      }

      function setFilter(next, label) {
        filter = (next || 'all').toLowerCase();
        pills.forEach((pill) => {
          const on = (pill.dataset.fbFilter || '').toLowerCase() === filter;
          pill.classList.toggle('is-on', on);
          pill.setAttribute('aria-pressed', String(on));
        });
        if (select && select.value !== filter) select.value = filter;
        if (showingLabel) {
          const activePill = pills.find((p) => (p.dataset.fbFilter || '').toLowerCase() === filter);
          showingLabel.textContent = label || activePill?.textContent?.trim() || 'All';
        }
        buildWall();
      }

      pills.forEach((pill) => {
        pill.addEventListener('click', () => setFilter(pill.dataset.fbFilter, pill.textContent.trim()));
      });
      select?.addEventListener('change', () => {
        const opt = select.selectedOptions?.[0];
        setFilter(select.value, opt?.textContent?.trim());
      });

      wall?.addEventListener('mouseenter', () => wall.classList.add('is-paused'));
      wall?.addEventListener('mouseleave', () => wall.classList.remove('is-paused'));

      let fbResize;
      window.addEventListener('resize', () => {
        clearTimeout(fbResize);
        fbResize = window.setTimeout(buildWall, 140);
      }, { passive: true });

      setFilter('all');
    }

    // Featured quote yellow bloom
    const fbFeatureHl = root.querySelector('[data-fb-feature-hl]');
    if (fbFeatureHl) {
      const lightFeature = () => fbFeatureHl.classList.add('is-lit');
      if (reducedMotion || !('IntersectionObserver' in window)) {
        lightFeature();
      } else {
        const fio = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            lightFeature();
            fio.disconnect();
          });
        }, { threshold: 0.45, rootMargin: '0px 0px -10% 0px' });
        fio.observe(fbFeatureHl);
      }
    }
  }


  function init(root) {
    if (root.dataset.mlInitialised) return;
    root.dataset.mlInitialised = 'true';
    const variantsNode = q(root, '[data-product-json]');
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (error) { variants = []; }
    let selected = variants.find((variant) => variant.available) || variants[0];
    const selectedValues = selected?.options ? [...selected.options] : [];
    const form = q(root, '[data-product-form]');
    const variantInput = q(root, '[data-variant-id]');
    const addButton = q(root, '[data-add-to-cart]');
    const addText = q(root, '[data-atc-text]');
    const priceNodes = qa(root, '[data-price]');
    const currency = root.dataset.currency || 'USD';
    const addToCartLabel = root.dataset.addToCartLabel || 'ADD TO CART';

    function syncVariant() {
      const candidate = variants.find((variant) => variant.options.every((value, index) => value === selectedValues[index]));
      if (candidate) selected = candidate;
      if (!selected) return;
      if (variantInput) variantInput.value = selected.id;
      priceNodes.forEach((node) => { node.textContent = money(selected.price, currency); });
      if (addButton) addButton.disabled = !selected.available;
      if (addText) addText.textContent = selected.available ? `${addToCartLabel} · ${money(selected.price, currency)}` : 'SOLD OUT';
      qa(root, '[data-option-index]').forEach((group) => {
        const optionIndex = Number(group.dataset.optionIndex);
        qa(group, '[data-option-value]').forEach((button) => {
          const active = button.dataset.optionValue === selectedValues[optionIndex];
          button.classList.toggle('is-on', active);
          button.setAttribute('aria-pressed', String(active));
        });
      });
    }

    qa(root, '[data-option-index]').forEach((group) => {
      group.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');
        if (!button || !group.contains(button)) return;
        selectedValues[Number(group.dataset.optionIndex)] = button.dataset.optionValue;
        syncVariant();
      });
    });
    syncVariant();

    const slides = qa(root, '[data-gallery-slide]');
    const thumbs = qa(root, '[data-gallery-thumb]');
    let galleryIndex = 0;
    function setSlide(next) {
      if (!slides.length) return;
      galleryIndex = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === galleryIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      thumbs.forEach((thumb, index) => {
        const active = index === galleryIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }
    q(root, '[data-gallery-prev]')?.addEventListener('click', () => setSlide(galleryIndex - 1));
    q(root, '[data-gallery-next]')?.addEventListener('click', () => setSlide(galleryIndex + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => setSlide(Number(thumb.dataset.galleryThumb))));
    let startX = 0, startY = 0;
    q(root, '[data-gallery-stage]')?.addEventListener('pointerdown', (event) => { startX = event.clientX; startY = event.clientY; });
    q(root, '[data-gallery-stage]')?.addEventListener('pointerup', (event) => {
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      const width = event.currentTarget.clientWidth || 1;
      if (Math.abs(dx) > width * 0.15 && Math.abs(dx) > Math.abs(dy)) setSlide(galleryIndex + (dx < 0 ? 1 : -1));
    });

    function scrollTo(selector, scope) {
      const el = (scope || root).querySelector(selector) || document.querySelector(selector);
      el?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }
    qa(root, '[data-scroll-buy]').forEach((button) => button.addEventListener('click', () => scrollTo(`#magicpad-buybox-${root.id.replace('magicpad-listicle-', '')}`)));
    qa(root, '[data-scroll-reviews]').forEach((button) => button.addEventListener('click', () => {
      const target = document.getElementById('ffdlp-fb-comments') || document.querySelector('[data-reviews]');
      target?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }));

    const modal = q(root, '[data-modal-overlay]');
    const modalBox = q(root, '.ml-modal__box');
    let lastFocus;
    function openModal(name) {
      if (!modal) return;
      lastFocus = document.activeElement;
      qa(root, '[data-modal-panel]').forEach((panel) => { panel.hidden = panel.dataset.modalPanel !== name; });
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      window.setTimeout(() => modalBox?.focus(), 50);
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lastFocus?.focus?.();
    }
    qa(root, '[data-open-modal]').forEach((button) => button.addEventListener('click', () => openModal(button.dataset.openModal)));
    q(root, '[data-close-modal]')?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal?.classList.contains('is-open')) closeModal(); });

    qa(root, '.ml-faq-item').forEach((item) => {
      q(item, '.ml-faq-question')?.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-active');
        qa(root, '.ml-faq-item').forEach((other) => {
          other.classList.remove('is-active');
          q(other, '.ml-faq-question')?.setAttribute('aria-expanded', 'false');
          const answer = q(other, '.ml-faq-answer');
          if (answer) answer.style.maxHeight = '';
        });
        if (!wasOpen) {
          item.classList.add('is-active');
          q(item, '.ml-faq-question')?.setAttribute('aria-expanded', 'true');
          const answer = q(item, '.ml-faq-answer');
          if (answer) answer.style.maxHeight = `${answer.scrollHeight}px`;
        }
      });
    });

    qa(root, '[data-offer]').forEach((offer) => offer.addEventListener('click', () => {
      qa(root, '[data-offer]').forEach((item) => { item.classList.remove('is-on'); item.setAttribute('aria-pressed', 'false'); });
      offer.classList.add('is-on'); offer.setAttribute('aria-pressed', 'true');
      window.setTimeout(() => {
        addButton?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        addButton?.classList.remove('is-pulse');
        void addButton?.offsetWidth;
        addButton?.classList.add('is-pulse');
      }, 150);
    }));

    qa(root, '[data-ugc-slide]').forEach((slide) => {
      const video = q(slide, 'video');
      if (!video) return;
      slide.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); });
      video.addEventListener('play', () => slide.classList.add('is-playing'));
      video.addEventListener('pause', () => slide.classList.remove('is-playing'));
    });
    const ugcRow = q(root, '[data-ugc-row]');
    function stepUGC(direction) {
      if (!ugcRow) return;
      const slide = q(ugcRow, '[data-ugc-slide]');
      if (!slide) return;
      const step = slide.getBoundingClientRect().width + 14;
      const max = ugcRow.scrollWidth - ugcRow.clientWidth;
      let target = ugcRow.scrollLeft + direction * step;
      if (direction > 0 && ugcRow.scrollLeft >= max - 8) target = 0;
      if (direction < 0 && ugcRow.scrollLeft <= 8) target = max;
      ugcRow.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    q(root, '[data-ugc-prev]')?.addEventListener('click', () => stepUGC(-1));
    q(root, '[data-ugc-next]')?.addEventListener('click', () => stepUGC(1));

    function equaliseReasons() {
      const cards = qa(root, '[data-reason-card]');
      cards.forEach((card) => { card.style.minHeight = ''; });
      if (window.innerWidth < 700) return;
      const tallest = Math.max(0, ...cards.map((card) => card.getBoundingClientRect().height));
      cards.forEach((card) => { card.style.minHeight = `${Math.ceil(tallest)}px`; });
    }
    let resizeTimer;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = window.setTimeout(equaliseReasons, 120); }, { passive: true });
    document.fonts?.ready?.then(equaliseReasons);
    equaliseReasons();

    // Fixed sticky CTA removed from FreshFlow listicle (ffdlp_offer).
    // Keep data-scroll-buy / inline CTAs; do not reintroduce #ctaBar / [data-fixed-cta].




    // Scroll reveal for the hero pivot line (“FreshFlow™ breaks that pattern.”)
    const intro = q(root, '.ml-hero__intro');
    if (intro) {
      const paragraphs = qa(intro, 'p');
      const pivot = paragraphs.find((p) => /breaks that pattern/i.test(p.textContent || ''))
        || paragraphs[paragraphs.length - 1];
      if (pivot && !pivot.classList.contains('ffdlp-pattern-break')) {
        pivot.classList.add('ffdlp-pattern-break');
        if (![...pivot.childNodes].some((n) => n.nodeType === 1 && n.classList?.contains('ffdlp-pattern-break__text'))) {
          const wrap = document.createElement('span');
          wrap.className = 'ffdlp-pattern-break__text';
          while (pivot.firstChild) wrap.appendChild(pivot.firstChild);
          pivot.appendChild(wrap);
        }
        const reveal = () => pivot.classList.add('is-in');
        if (reducedMotion || !('IntersectionObserver' in window)) {
          reveal();
        } else {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              reveal();
              io.disconnect();
            });
          }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
          io.observe(pivot);
        }
      }
    }

    // Scroll yellow bloom on 5 Reasons highlight — only when title scrolls into view
    const reasonsHighlight = q(root, '.ffdlp-reasons-highlight');
    const reasonsTitle = q(root, '.ffdlp-reasons-title');
    if (reasonsHighlight) {
      reasonsHighlight.classList.remove('is-in');
      const revealReasons = () => {
        if (reasonsHighlight.classList.contains('is-in')) return;
        // restart transition from collapsed state
        reasonsHighlight.classList.remove('is-in');
        void reasonsHighlight.offsetWidth;
        reasonsHighlight.classList.add('is-in');
      };
      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealReasons();
      } else {
        const target = reasonsTitle || reasonsHighlight;
        const rio = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            // Must be coming into the upper/mid viewport, not already parked on load
            const top = entry.boundingClientRect.top;
            const vh = window.innerHeight || 800;
            if (top > vh * 0.05 && top < vh * 0.72) {
              revealReasons();
              rio.disconnect();
            }
          });
        }, { threshold: [0, 0.25, 0.5, 0.75], rootMargin: '0px 0px -28% 0px' });
        rio.observe(target);
        // If already deep past the section (e.g. restored scroll), show final state without animating from mid-page
        const rect = target.getBoundingClientRect();
        const vh = window.innerHeight || 800;
        if (rect.bottom < vh * 0.2) {
          reasonsHighlight.classList.add('is-in');
          rio.disconnect();
        }
      }
    }



    initReviewMarquee(root);

    if (q(root, '[data-fb-comments]')) initFbComments(root);



  }

  function boot() {
    qa(document, '[data-ff-dog-listiclepdp]').forEach(init);
    qa(document, '[data-ffdlp-fb-comments]').forEach(initFbComments);
  }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
})();

/* Listicle video assist: keep muted + kick play() (browsers ignore HTML autoplay
   with many videos). Do NOT unload/pause aggressively — that caused slow reloads. */
(function () {
  var SEL = [
    '.ff-dog-listiclepdp video.ffdlp-autoplay-video',
    '.ff-dog-listiclepdp .ffdlp-reason-video',
    '.ff-dog-listiclepdp .ffdlp-hero-video__media'
  ].join(', ');

  function prepare(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.loop = true;
    video.controls = false;
    video.removeAttribute('controls');
  }

  function heroHidden(video) {
    if (video.closest('.ffdlp-hero-video--desktop') && !window.matchMedia('(min-width: 860px)').matches) return true;
    if (video.closest('.ffdlp-hero-video--mobile') && window.matchMedia('(min-width: 860px)').matches) return true;
    return false;
  }

  function kick(video) {
    if (heroHidden(video)) return;
    prepare(video);
    if (video.paused) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function boot() {
    var nodes = document.querySelectorAll(SEL);
    nodes.forEach(prepare);

    // Immediate kick for anything already on screen
    nodes.forEach(function (video) {
      if (heroHidden(video)) return;
      var rect = video.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      if (rect.bottom > 0 && rect.top < vh) kick(video);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) kick(entry.target);
        });
      }, { rootMargin: '20% 0px', threshold: 0.15 });
      nodes.forEach(function (v) { io.observe(v); });
    }

    window.addEventListener('resize', function () {
      document.querySelectorAll(SEL).forEach(function (video) {
        if (heroHidden(video)) {
          try { video.pause(); } catch (e) {}
        } else {
          var rect = video.getBoundingClientRect();
          var vh = window.innerHeight || 800;
          if (rect.bottom > 0 && rect.top < vh) kick(video);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
